import { initialiseComponents } from "../../core";
import Component from "../component.abstract";
import { setTimeZone } from "../helpers/date";
import Candidatures from "./candidatures-home";

interface CandidaturesItemProps {
    idx: string;
}

export default class CandidaturesItem extends Component {
  private idx: number;
  private done = false;
  private data: any;
  constructor(private props: CandidaturesItemProps, element: HTMLElement) {
    super(props, element);
    this.idx = parseInt(props.idx);
  }

  mounted(): void {
    this.injectTemplate();

    PubSub.subscribe("candidatures.loaded", (msg:string, instance: Candidatures) => {
      this.populate(instance);
    });
  }
  populate(candidatures: Candidatures):void {
    if(this.done) {
        return;
    }
    const data = candidatures.data;
    if(data) {
        if(data.items.length > this.idx) {
            this.data = data.items[this.idx]
            const attrs = this.element.querySelectorAll("[data-attr]");
             for (let i = 0; i < attrs.length; i++) {
                 let js:any = attrs[i].getAttribute("data-attr");
                 try {
                   js = JSON.parse(js);
                 } catch (e) {
                   const tmp:any = [{}];
                   tmp[0].attr = "innerText";
                   tmp[0].value = js;
                   js = tmp;
                 }
                 for (let j = 0; j < js.length; j++) {
                   if (this.data[js[j].value]) {
                     if (js[j].attr && js[j].attr != "innerText") {
                       attrs[i].setAttribute(
                         js[j].attr,
                         this.data[js[j].value]
                       );
                     } else {
                       (<HTMLElement>attrs[i]).innerText = this.data[js[j].value];
                     }
                   } else {
                     if (js[j].attr && js[j].attr != "innerText") {
                       attrs[i].setAttribute(js[j].attr, "");
                     } else {
                       (<HTMLElement>attrs[i]).innerText = "";
                     }
                   }
                 }
             }

              const spans = this.element.querySelectorAll("span:not(.indic)");

              const now = new Date();
              const nowD = now.getDay();
              const nowZone = setTimeZone(new Date())
              const nowTime = nowZone.valueOf()
              const dt = new Date(this.data["applyDate"]);
              const dtD = dt.getDay();
              const dateText =
                dt.getDate() +
                "/" +
                ((dt.getMonth() + 1 < 10 ? "0" : "") + (dt.getMonth() + 1)) +
                "/" +
                dt.getFullYear();
              const dtTime = nowTime - dt.getTime();

              const mapping = [
                { dif: "15000", text: "Il y a un instant" },
                { dif: "60000", text: "Il y a moins d'une minute" },
                { dif: "120000", text: "Il y a environ une minute" },
                {
                  dif: "3600000",
                  text: "Il y a " + Math.floor(dtTime / 60000) + " minutes",
                },
                { dif: "4800000", text: "Il y a 1 heure" },
                {
                  dif: "86400000",
                  text:
                    nowD == dtD
                      ? "Il y a " + Math.floor(dtTime / 60000 / 60) + " heures"
                      : "Hier",
                },
              ];

              let timeText: string;
              for (let i = 0; i < mapping.length && !timeText; i++) {
                if (dtTime < parseInt(mapping[i].dif)) {
                  timeText = mapping[i].text;
                }
              }
              if (!timeText) {
                timeText = dateText;
              }

              spans[0].innerHTML = timeText;

              spans[2].innerHTML = this.data["title"];

              initialiseComponents();



        }
        this.done = true;
    }
  }
}
